var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#2C3941"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8333 11.8333C11.8333 9.49996 13.6667 7.66663 16 7.66663C18.3333 7.66663 20.1667 9.49996 20.1667 11.8333C20.1667 14.1666 18.3333 16 16 16C13.6667 16 11.8333 14.1666 11.8333 11.8333ZM23.5 21.8333V23.5C23.5 24 23.1667 24.3333 22.6667 24.3333C22.1667 24.3333 21.8333 24 21.8333 23.5V21.8333C21.8333 20.4166 20.75 19.3333 19.3333 19.3333H12.6667C11.25 19.3333 10.1667 20.4166 10.1667 21.8333V23.5C10.1667 24 9.83333 24.3333 9.33333 24.3333C8.83333 24.3333 8.5 24 8.5 23.5V21.8333C8.5 19.5 10.3333 17.6666 12.6667 17.6666H19.3333C21.6667 17.6666 23.5 19.5 23.5 21.8333ZM16 14.3333C14.5833 14.3333 13.5 13.25 13.5 11.8333C13.5 10.4166 14.5833 9.33329 16 9.33329C17.4167 9.33329 18.5 10.4166 18.5 11.8333C18.5 13.25 17.4167 14.3333 16 14.3333Z",
    fill: "#2C3941"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonNotification);
export default __webpack_public_path__ + "static/media/person-notification.12bfcf363494c1623de1a27dd4733a16.svg";
export { ForwardRef as ReactComponent };